/**
 * Return an absolute HTTP(S) URL for values that are safe to place in
 * clickable browser navigation surfaces.
 */
export function safeHttpUrl(value?: string | null): string | undefined {
  if (typeof value !== 'string') return undefined;

  const trimmed = value.trim();
  if (!trimmed) return undefined;

  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}
